import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ roles, children }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="auth-loading" data-testid="auth-loading">
        <div className="auth-loading-spinner" />
        <p>Cargando…</p>
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login-profesoras" replace />;
  }

  if (roles && !roles.includes(user.role)) {
    // role mismatch — redirect by role
    return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard-profesora"} replace />;
  }

  return children;
};

export default ProtectedRoute;
